export const physicianModalTableActions = (onClick, props) => [
  {
    onClick,
    text: 'CLOSE',
    size: 'medium',
    variant: 'outlined',
    ...props,
  },
];
